<template>
  <custom-callout
    border-color="primary-2"
    class="mb-4 custom-callout rounded"
    :has-toggle="false"
  >
    <div class="py-3 pr-4">
      <div class="d-flex">
        <icon-view
          class="mt-5 mb-3 mt-md-0 mt-sm-5"
          :gradient="false"
          icon="fas fa-file-invoice mb-1"
          icon-background="white"
          icon-color="#FF7058"
          icon-size="16px"
          title="Añadir Nuevo Referido a Rehabilitación Vocacional (ARV)"
        />
      </div>

      <validation-observer ref="addReferralObserver">
        <div class="row my-2 ml-4">
          <div class="col-md-4 col-sm-12 mr-md mb-2">
            <validation-provider
              v-slot="{ errors }"
              :rules="ssnRules"
              :custom-messages="{
                required: 'El número de Seguro Social es requerido.',
                completePersonalssn:
                  'El número de Seguro Social debe ser correcto.',
              }"
            >
              <label for="txtReferralSSN" class="data-name">
                Núm. Seguro Social:
              </label>
              <custom-input
                id="txtReferralSSN"
                v-model="model.ssn"
                mask-type="Personalssn"
                maxlength="11"
                placeholder="xxx-xx-xxxx"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
              />
            </validation-provider>
          </div>

          <div class="col-md-4 col-sm-12 mr-md mb-2">
            <student-sie-search
              v-model="model.students"
              :limit="1"
              :statuses-allowed="allowedStatuses"
              custom-error-msg="El estudiante es requerido y El estatus debe ser Servido."
              :show-selected="false"
            />
          </div>
          <div class="col-md-4 d-flex align-items-center justify-content-end">
            <action-button
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger mr-3 pl-3 pr-4"
              @click="onClose"
            />
            <action-button
              i="fas fa-arrow-circle-right"
              text="Continuar"
              variant="success pl-3 pr-3"
              :disabled="!canContinue"
              @click="onContinue"
            />
          </div>
        </div>
        <div v-if="selectedStudent">
          <div class="my-3">
            <div class="py-2">
              <icon-view
                icon="fas fa-user-circle fa-lg text-orange"
                variant="custom-icon-view"
                icon-background="white"
                title="Estudiante Seleccionado"
              />
            </div>
            <div class="px-3 py-2">
              <div
                class="row font-weight-normal p-3 rounded custom-row bg-white rounded"
              >
                <div class="col-md-3 col-12">
                  <div class="color-secondary-6 font-14">
                    Nombre del Estudiante:
                  </div>
                  <div class="color-black font-16 text-break">
                    {{ selectedStudent.fullName | empty }}
                  </div>
                </div>
                <div class="col-md col-12">
                  <div class="color-secondary-6 font-14">
                    SIE:
                  </div>
                  <div class="color-black font-16 text-break">
                    {{ selectedStudent.studentId | empty }}
                  </div>
                </div>
                <div class="col-md col-12">
                  <div class="color-secondary-6 font-14">
                    Edad:
                  </div>
                  <div class="color-black font-16 text-break">
                    {{ selectedStudent.age | age | empty }}
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <div class="color-secondary-6 font-14">
                    Impedimento:
                  </div>
                  <div class="color-black font-16 text-break">
                    {{ selectedStudent.impediment | empty }}
                  </div>
                </div>
                <div class="col-md col-12">
                  <div class="color-secondary-6 font-14">
                    Estatus:
                  </div>
                  <div class="color-black font-16 text-break">
                    {{ selectedStudent.status | empty }}
                  </div>
                </div>
                <div
                  class="col-md-1 col-12 d-flex align-items-center justify-content-end"
                >
                  <action-button
                    i="fas fa-times-circle"
                    variant="outline-danger"
                    @click="quitStudent"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import CustomInput from '@/components/common/CustomInput';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import StudentSieSearch from '@/components/student/StudentSieSearch.vue';
import StudentStatuses from '@/utils/constants/student/studentStatuses.js';

export default {
  name: 'VocationalRehabilitationReferralAdd',
  components: {
    CustomCallout,
    ActionButton,
    IconView,
    CustomInput,
    ValidationObserver,
    ValidationProvider,
    StudentSieSearch,
  },
  data() {
    return {
      model: {
        ssn: '',
        students: [],
      },
    };
  },
  computed: {
    selectedStudent() {
      return this.model.students[0] ?? null;
    },
    allowedStatuses() {
      return [StudentStatuses.Servido];
    },
    ssnRules() {
      return {
        required: true,
        completePersonalssn: true,
      };
    },
    canContinue() {
      return (
        this.selectedStudent &&
        this.model.ssn &&
        !this.$refs.addReferralObserver?.invalid
      );
    },
  },
  methods: {
    onClose() {
      this.resetForm();
      this.$emit('close');
    },
    normalizeSSN(value) {
      return String(value || '').replace(/\D/g, '');
    },
    onContinue() {
      this.$emit('continue', {
        ssn: this.normalizeSSN(this.model.ssn) || null,
        sie: this.selectedStudent?.studentId || null,
      });
      this.resetForm();
    },
    resetForm() {
      this.model.ssn = '';
      this.model.students = [];
      this.$refs.addReferralObserver?.reset();
    },
    quitStudent() {
      this.model.students = [];
    },
  },
};
</script>

<style scoped></style>
